/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const commissionSearchAPI = function (data) {
    const url = `${config.baseUrl}commission/search`;
    return postRequest({
        url,
        data,
    });
};

export const commissionCreateAPI = function (data) {
    const url = `${config.baseUrl}commission`;
    return postRequest({
        url,
        data,
    });
};

export const commissionUpdateAPI = function ({
    commissionId,
    data,
}) {
    const url = `${config.baseUrl}commission/${commissionId}`;
    return putRequest({
        url,
        data,
    });
};
